import dev from "./dev.js";
import staging from "./staging.js";
import prod from "./prod.js";

type Environment = "dev" | "staging" | "prod";
type Config = typeof dev | typeof staging | typeof prod;

const environmentLookup: Record<Environment, Config> = {
  dev,
  staging,
  prod,
};

const hostnameLookup: Record<string, Environment> = {
  "auth.crossbeam.com": "prod",
  "auth.cb.c7m.io": "staging",
  "auth.crossbeam-dev.com": "dev",
};

function detectEnvironment(): Environment {
  if (typeof window === "undefined") {
    // Server-side or test environment, default to dev
    return "dev";
  }

  const hostname = window.location.hostname;

  // Check exact hostname matches
  if (hostnameLookup[hostname]) {
    return hostnameLookup[hostname];
  }

  // Default to dev for localhost or unknown domains
  return "dev";
}

const config = environmentLookup[detectEnvironment()];

export default config;
